import React from 'react';
import styled, { keyframes } from 'styled-components';
import { contentColumnPadding } from '../../theme/constants';

interface Props {
  text?: string;
}

const ThinkingIndicator: React.FC<Props> = ({ text = 'Thinking...' }) => {
  return (
    <Wrapper>
      <DotsRow>
        <Dot $delay={0} />
        <Dot $delay={0.2} />
        <Dot $delay={0.4} />
      </DotsRow>
      <Text>{text}</Text>
    </Wrapper>
  );
};

export default ThinkingIndicator;

const pulse = keyframes`
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40%           { transform: scale(1);   opacity: 1;   }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  color: ${({ theme }) => theme.av2.textMuted};
`;

const DotsRow = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const Dot = styled.span<{ $delay: number }>`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ theme }) => theme.av2.primary};
  animation: ${pulse} 1.2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;

const Text = styled.span`
  font-size: 13px;
`;
